import React from "react";
import HeaderNavigation from "../../../components/layout/HeaderNavigation";
import * as Animate from "react-reveal";

import MapImage from "../../../assets/images/png/about-map.webp";
import BorderGradient from "../../../components/blocks/BorderGradient";

const AboutHeader = () => {
  return (
    <header className="w-full bg-blue2">
      <HeaderNavigation bgdark={true} />
      <div className="pt-8 md:pt-12 lg:pt-16 pb-20 lg:pb-24 container mx-auto px-4">
        <div className="w-full md:10/12 lg:w-8/12 mx-auto text-center relative">
          <Animate.Fade bottom>
            <h2 className="w-full md:w-11/12 lg:w-10/12 mx-auto text-3xl lg:text-4xl xl:text-5xl leading-relaxed xl:leading-tight font-semibold text-white font-mono py-6">
              Digital Transformation for Individuals and Businesses.
            </h2>
            <p className="text-white text-base md:text-lg leading-8 py-6 w-full lg:w-11/12 xl:w-9/12 mx-auto">
              We are a Technology Workforce Development company that helps
              people learn premium technology skills virtually and partners with
              companies to hire the best talents and invest in workforce
              development. Currently with learners from 19 countries.
            </p>
          </Animate.Fade>
        </div>
      </div>

      <div className="w-full relative">
        <img src={MapImage} alt="Map" />
      </div>

      <div className="grid grid-cols-3 ">
        <BorderGradient />
      </div>
    </header>
  );
};

export default AboutHeader;
